import React, { useState } from "react";
import { Container } from "./styled";

const VideoSlider = (updateWindowDimensions) => {
  const [isVideoContainerOpen, setIsVideoContainerOpen] = useState(false);
  const [videoSrc, setVideoSrc] = useState("");
  const [videoFileValue, setVideoFileValue] = useState("");

  const toogleVideoContainer = () => {
    setIsVideoContainerOpen(!isVideoContainerOpen);
    let videoContainer = document.getElementById("court-container");
    if (videoContainer.classList.contains("open"))
      videoContainer.classList.remove("open");
    else videoContainer.classList.add("open");
    updateWindowDimensions.updateWindowDimensions();
  };

  //Handle Upload of the video
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    const blobURL = URL.createObjectURL(file);
    setVideoFileValue(file);
    setVideoSrc(blobURL);
  };
  return (
    <Container
      id="toogle"
      className={`${isVideoContainerOpen ? "" : "collapsed"}`}
    >
      <div class="sidebar-top">
        <div class="expand-btn" onClick={(e) => toogleVideoContainer()}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="white"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
            <path d="M7 7l5 5l-5 5"></path>
            <path d="M13 7l5 5l-5 5"></path>
          </svg>
        </div>
      </div>
      <div className="side-video-container">
        <input type="file" accept="video/*" onChange={handleFileUpload} />
        {videoSrc.length ? (
          <video src={videoSrc} controls playsInline className="videoPlayer">
            <source src={videoSrc} type={videoFileValue.type} />
          </video>
        ) : null}
      </div>
    </Container>
  );
};

export default VideoSlider;
